import { theme, TagIcon } from "@pinkyhead/dovekit";
import { ReactComponent as CheckIcon } from "../../../assets/icons/solid/check.svg";
import { ReactComponent as CrownIcon } from "../../../assets/icons/solid/crown.svg";
import { ReactComponent as ThumbIcon } from "../../../assets/icons/solid/thumb_up.svg";
import { TagIconsProps } from "./TagIcons.interface";
import { Container } from "./TagIcons.styles";

export const TagIcons = ({ isClaimed, isPremium, isRecommended }: TagIconsProps) => {
  return (
    <Container>
      {isClaimed &&
        <TagIcon 
          backgroundColor={theme.colors.additional.green[50]}
          color={theme.colors.additional.green[300]}
          icon={<CheckIcon />}
          label="Claimed"
        />
      }
      {isRecommended &&
        <TagIcon 
          backgroundColor={theme.colors.additional.purple[50]}
          color={theme.colors.additional.purple[300]}
          icon={<ThumbIcon />}
          label="Recommended"
        />
      }
      {isPremium &&
        <TagIcon 
          backgroundColor={theme.colors.additional.orange[50]}
          color={theme.colors.additional.orange[300]}
          icon={<CrownIcon />}
          label="Premium"
        />
      }
    </Container>
  )
}
